<template>
  <main class="queryDetail container-fluid mf_container pb_50 mb_20">
    <div class="row mt_15">
      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-default" @click="goback()">重新搜尋</button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="selectInsered">
          <h4 class="d-flex align-items-center">
            請選擇被保險人:
            <div class="text-red ml_8" style="font-size: 13px">
              需要被保人已於 CRM
              輸入身分證字號，且建議書主約為傳統型現售商品，才能使用E檢核功能
            </div>
          </h4>
          <div class="selectInsered__list pt_7">
            <div
              class="inseredTab mr_5 mb_10"
              :class="{ active: people.csidno == nowShowInsuredId }"
              @click="changeShowInsured(people)"
              v-for="people in getAllFamilyResult"
              :key="people.csidno"
            >
              <Avatar
                class="mr-2"
                :gender="Number(people.sex)"
                :size="20"
                :height="20"
              />
              <div class="inseredTab__name">{{ truncate(people.name) }}</div>
            </div>
          </div>
        </div>

        <!-- 傳統列表 -->
        <div v-if="proposalDetailList_TD.length > 0">
          <div class="queryDetail__title mt_10">
            <div
              class="queryDetail__title--tag"
              style="background-color: #027a39"
            ></div>
            <h5>傳統型商品</h5>
          </div>
          <QueryContractItemTD
            v-for="(contractItem, index) in proposalDetailList_TD"
            :NO="proposalDetailList_TD.length - index"
            :key="contractItem.prod_idx"
            selectedMode="checkbox"
            :contractData="contractItem"
            :isChecked.sync="contractItem.is_checked"
          ></QueryContractItemTD>
        </div>
        <div
          class="queryDetail__empty"
          v-if="proposalDetailList_TD.length == 0"
        >
          {{ emptyText }}
        </div>
      </div>
    </div>
    <form
      :action="
        `${formSubmitURL}cathaylife.com.tw/ATWeb/servlet/HttpDispatcher/ATA0_7500/query`
      "
      method="GET"
      ref="submit"
      style="display: none"
      target="_blank"
      accept="BIG5"
      accept-charset="BIG5"
    ></form>
    <ChangePopup
      :crmMapList="crmMapList"
      :oldCrmMapList="oldCrmMapList"
      v-if="changePopupHandler"
      @cancel="changePopupHandler = false"
      @finish="toHandler"
    />
    <FixedBottom v-show="proposalDetailList_TD.length > 0">
      <template slot="@function">
        <div class="d-flex justify-content-end">
          <button
            class="btn btn-default px_5 mr_10"
            type="button"
            @click="next()"
            :disabled="nowSelectProposalList.length == 0"
          >
            顯示體檢資訊
          </button>
        </div>
      </template>
    </FixedBottom>
  </main>
</template>

<script>
import { getAllFamily } from "@/service";
import _ from "lodash";
import mf_Mixin from "@/desktop/views/mf/mixin";
import Avatar from "@/desktop/components/Avatar";
import QueryContractItemTD from "@/desktop/views/mf/components/QueryContractItem_TD";
import QueryContractItemIV from "@/desktop/views/mf/components/QueryContractItem_IV";

import FixedBottom from "@/desktop/views/mf/components/fixedBotton";
import ChangePopup from "@/desktop/views/mf/components/2.Query/2-3-1.QueryDetail/ChangePopup.vue";
import { computeAge } from "@/service";
export default {
  mixins: [mf_Mixin],
  components: {
    Avatar,
    QueryContractItemTD,
    QueryContractItemIV,
    FixedBottom,
    ChangePopup
  },
  data() {
    return {
      getAllFamilyResult: [], //加戶列表
      proposalDetailList_TD: [], //傳統型列表
      nowShowInsuredId: "", //目前檢視的被保人ID
      tempNowSelectProposal: null, //已壓上新資料重算，但不確定是user是否使用的暫存
      emptyText: "查詢中...",
      crmMapList: {},
      oldCrmMapList: {}, //出現差異的人們
      changePopupHandler: false,
      toHandler: () => {}
    };
  },
  computed: {
    insured_id() {
      return this.$store.getters.QueryDetailTarget.insured_id;
    },
    prod_idx() {
      return this.$store.getters.QueryDetailTarget.prod_idx;
    },
    familyid() {
      return this.$store.getters.QueryDetailTarget.familyid;
    },
    nowSelectProposalList() {
      //目前勾選的建議書
      return this.proposalDetailList_TD.filter(item => {
        return item.is_checked;
      });
    },
    formSubmitURL() {
      let href = window.location.href; // 設定動態 url
      let netzone = "https://twas2.";
      if (href.indexOf("tmycrm") !== -1) {
        netzone = "https://twas2.";
      } else if (href.indexOf("smycrm") !== -1) {
        netzone = "https://swas2.";
      } else if (href.indexOf("mycrm") !== -1) {
        netzone = "https://was2.";
      }
      return netzone;
    }
  },
  beforeCreate() {},
  created() {
    if (this.$store.getters.QueryDetailTarget.is_crm == "") {
      return this.$router.replace("/mf/eReview");
    }
    this.init();
  },

  methods: {
    async init() {
      const result = await getAllFamily(
        this.$store.state.userInfo.id,
        this.familyid,
        this.$store.getters.IsBankUser
      );
      this.getAllFamilyResult = result.data;
      this.crmMapList = {}; //家戶現況原始資料
      result.data.forEach(item => {
        this.crmMapList[item.csidno] = {
          insured_name: item.name,
          insured_birthday: item.birthday || "",
          insured_gender: item.sex,
          insured_age: item.age + ""
        };
      });
      this.nowShowInsuredId = this.insured_id;
      this.getProposalDetailList();
    },
    getProposalDetailList() {
      this.$store.commit("update_mfLoadingMask", true);
      this.$mfAPI
        .MFA0_1000__queryProposalDetailList({
          agent_id: this.$store.state.userInfo.id,
          insured_id: this.nowShowInsuredId,
          prod_idx: this.prod_idx
        })
        .then(res => {
          this.$store.commit("update_mfLoadingMask", false);
          this.emptyText = "尚未為客戶新增建議書，故無可查詢資訊";
          this.proposalDetailList_TD = res.proposal.filter(proposal => {
            proposal.mc_prod_list = proposal.mc_prod_list.filter(mc => {
              return mc.feed_back_antypt != "1";
            });
            return proposal.mc_prod_list.length > 0;
          });
          setTimeout(() => {
            this.registerHanlink();
          }, 500);
        })
        .catch(() => {
          this.$store.commit("update_mfLoadingMask", false);
        });
    },
    changeShowInsured(people) {
      this.proposalDetailList_TD = [];
      this.emptyText = "查詢中...";
      this.nowShowInsuredId = people.csidno;
      this.getProposalDetailList();
    },
    goback() {
      this.$router.push(`/mf/eReview${this.is_crm == "0" ? "?noId=1" : ""}`);
      this.$store.commit("reset_Customer");
      this.getAllFamilyResult = [];
      this.proposalDetailList_TD = [];
    },
    async next() {
      if (this.nowSelectProposalList.length == 0) {
        return this.$toast.info({ title: `請先選擇一組建議!` });
      }
      this.$mfAPI
        .MFA0_2000__eCheck({
          proposalList: this.nowSelectProposalList
        })
        .then(res => {
          //開始組建formData
          let formData = {};
          //業務員資料相關
          formData.AGENT_ID1 = this.$store.state.userInfo.id;
          //被保人資料相關
          formData.ID = this.nowSelectProposalList[0].insured_id;
          formData.NAME = this.nowSelectProposalList[0].insured_name;
          formData.BIRTHDAY = this.nowSelectProposalList[0].insured_birthday;
          formData.GENDER = this.nowSelectProposalList[0].insured_gender;
          //寫死
          formData.TxRequest = true;
          formData.queryType = 1;
          formData.subcode = "ATA0";
          formData.syscode = "AT";
          //後端計算
          formData.HEALTH_PROD_ID = res.health_prod_id || "";
          formData.FIX_PROD_ID = res.fix_prod_id || "";
          formData.FREE_FACE_AMT = res.free_face_amt;
          formData.FREE_PROD_ID = res.free_prod_id || "";
          formData.FIX_FACE_AMT = res.fix_face_amt || 0;
          formData.IS_ASSURED_FREE = res.fix_face_amt || 0;
          formData.IS_HEALTH = res.is_health;
          formData.HEALTH_FACE_AMT = res.health_face_amt;

          let fromElement = this.$refs.submit;
          let url = fromElement.action + "?";
          fromElement.replaceChildren();
          for (let keyName in formData) {
            let opt = document.createElement("textarea");
            opt.name = keyName;
            opt.value = formData[keyName];
            url += `${keyName}=${formData[keyName]}&`;
            fromElement.appendChild(opt);
          }
          this.nowSelectProposalList.forEach(proposal => {
            proposal.mc_prod_list.forEach(mc => {
              let opt_prod_id = document.createElement("textarea");
              opt_prod_id.name = "PROD_ID";
              opt_prod_id.value = mc.prod_id;
              url += `${opt_prod_id.name}=${opt_prod_id.value}&`;
              fromElement.appendChild(opt_prod_id);

              let opt_amt = document.createElement("textarea");
              opt_amt.name = "FACE_AMT";
              opt_amt.value = mc.amt;
              url += `${opt_amt.name}=${opt_amt.value}&`;
              fromElement.appendChild(opt_amt);

              let opt_amt_unit = document.createElement("textarea");
              opt_amt_unit.name = "FACE_AMT_UNIT";
              opt_amt_unit.value = mc.amt_unit;
              url += `${opt_amt_unit.name}=${opt_amt_unit.value}&`;
              fromElement.appendChild(opt_amt_unit);

              let opt_pay_prd = document.createElement("textarea");
              opt_pay_prd.name = "PAY_PERIOD";
              opt_pay_prd.value = mc.pay_prd;
              url += `${opt_pay_prd.name}=${opt_pay_prd.value}&`;
              fromElement.appendChild(opt_pay_prd);

              let opt_pol_period = document.createElement("textarea");
              opt_pol_period.name = "POL_PERIOD";
              opt_pol_period.value = mc.pol_period;
              url += `${opt_pol_period.name}=${opt_pol_period.value}&`;
              fromElement.appendChild(opt_pol_period);

              // fromURL += `PROD_ID=${mc.prod_id}&`;
              // fromURL += `FACE_AMT=${mc.amt}&`;
              // fromURL += `FACE_AMT_UNIT=${mc.amt_unit}&`;
              // fromURL += `PAY_PERIOD=${mc.pay_prd}&`;
              // fromURL += `POL_PERIOD=${mc.pol_period}&`;
            });
          });
          if (this.$store.state.userInfo.userType === "box") {
            //是否來源為Box(解決Nap無法開啟分頁問題))
            window.webkit.messageHandlers.getECheckUrl.postMessage(url);
          } else {
            fromElement.submit();
          }
        });
    }
  }
};
</script>

<style lang="scss">
.queryDetail {
  @media (min-width: 1025px) {
    width: 100%;
    max-width: 1280px;
  }
  .selectInsered {
    border-bottom: solid 1px #c2c4c7;
    &__list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .inseredTab {
        width: 166px;
        display: flex;
        padding: 10px;
        border-radius: 25px;
        border: solid 1px #c2c4c7;
        background-color: #fff;
        cursor: pointer;
        &__name {
          flex-grow: 1;
          text-align: center;
        }
        &.active {
          border: solid 1px #f58818;
          background-color: #feeedd;
        }
      }
    }
  }
  &__title {
    display: flex;
    align-items: center;
    &--tag {
      width: 8px;
      height: 24px;
      margin: 0 4px 1px 0;
    }
  }
}
.queryDetail__empty {
  min-height: 55vh;
  margin-bottom: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #323a45;
}
</style>
